export function initColorBlind() {
    const modeSwitch = document.getElementById("colorBlindModeToggle");
    if (!modeSwitch) {
        return;
    }
    modeSwitch.checked = isColorBlindMode();
    modeSwitch.onclick = () => {
        if (modeSwitch.checked) {
            localStorage.setItem("colorBlindMode", "true");
        } else {
            localStorage.setItem("colorBlindMode", "false");
        }
        window.location.reload();
    };
}

export function isColorBlindMode() {
    const prefs = localStorage.getItem("colorBlindMode");
    if (prefs === null) {
        localStorage.setItem("colorBlindMode", "false");
        return false;
    }
    return prefs === "true";
}
